<template>
    <div class="mobile-footer">
        <button class="backbutton">
            <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                width="13.333px" height="22.5px" viewBox="0 0 13.333 22.5" enable-background="new 0 0 13.333 22.5" xml:space="preserve">
            <g transform="translate(250.64631,-1811.0879)">
                <path fill="#292E33" stroke="#292E33" stroke-miterlimit="10" d="M-237.975,1812.988l-3.979,3.98
                    c-4.904,4.904-5.309,5.352-5.309,5.352s0.405,0.383,5.334,5.312l4.004,4.004l-0.614,0.614c-0.247,0.247-0.461,0.46-0.64,0.635
                    c-0.924-0.914-2.828-2.81-5.32-5.301l-5.28-5.28l5.264-5.264c2.483-2.483,4.381-4.373,5.303-5.285
                    C-239.033,1811.931-237.975,1812.988-237.975,1812.988z"/>
            </g>
            </svg>
            Back
        </button>
    </div>
</template>

<script>    
    export default {
        name: 'BackButtonMobile'
    }
</script>

<style lang="scss">
    .mobile-footer {
        margin-top: 50px;
        background: #282D33;
        padding-top: 10px;
        padding-bottom: 10px;
        display: flex;
        justify-content: center;
    }
    .backbutton {
        background: #ffffff;
        display: flex;
        align-items: center;
        padding: 10px 30px;
        border-top-left-radius: 30px;
        border-bottom-left-radius: 30px;
        border-top-right-radius: 30px;
        border-bottom-right-radius: 30px;
        font-weight : bold;
        font-size : 18px;

        svg {
            margin-right: 20px;
        }
    }
</style>